import {
    Grid,
    List,
    ListItem,
    ListItemAvatar,
    IconButton,
    ListItemText,
    ListItemSecondaryAction
} from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFile, faTimes } from '@fortawesome/free-solid-svg-icons'

import './style.css'

const FileList = ({items}) => {
    const convertFileSize = (originalFileSize, targetFormat = "MB") => {
        const k = 1024
        const i = Math.floor(Math.log(originalFileSize) / Math.log(k))
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

        return `${parseFloat((originalFileSize / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`
    }

    return (
        <Grid>
            <div>
                <List dense={false}>
                   {items.length > 0 && items.map((item, i) => (
                        <ListItem className="list__list-item" key={i}>
                            <ListItemAvatar className="list-item-avatar">
                                <FontAwesomeIcon icon={faFile} className="attachment-icon"/>
                            </ListItemAvatar>
                            <ListItemText className="list-item-text" primary={item.name} secondary={convertFileSize(item.size)}/>
                            <ListItemAvatar className="list-item-avatar">
                                <FontAwesomeIcon icon={faTimes}/>
                            </ListItemAvatar>
                        </ListItem>
                   ))}
                </List>
            </div>
        </Grid>
    )
}

export default FileList